<template>
  <div class="actions">
    <button
      @click="$emit('toggleVideo')"
      :class="isContentSelected('video')"
      v-tooltip="{
        content: 'Open Video',
        placement: 'bottom-center',
      }"
    >
      <VideoIcon :fill="hasCompleted('video')" class="actions__icon" />
    </button>
    <button
      v-if="hasQuiz && hasQuiz.length"
      @click="$emit('toggleQuiz')"
      :class="isContentSelected('quiz')"
      v-tooltip="{
        content: 'Open Quiz',
        placement: 'bottom-center',
      }"
    >
      <QuizIcon :fill="hasCompleted('quiz')" class="actions__icon" />
    </button>
  </div>
</template>

<script>
import QuizIcon from '@/assets/icons/course/quiz_icon.svg'
import VideoIcon from '@/assets/icons/course/video_icon.svg'

export default {
  name: 'Actions',
  components: {
    QuizIcon: { ...QuizIcon, name: 'QuizIcon' },
    VideoIcon: { ...VideoIcon, name: 'VideoIcon' },
  },
  props: {
    hasWatched: {
      type: Boolean,
      required: true,
    },
    isWatching: {
      type: Boolean,
      required: true,
    },
    hasQuiz: {
      type: [String, Array],
      required: false,
    },
    hasPassedQuiz: {
      type: Boolean,
      required: true,
    },
    isTakingQuiz: {
      type: Boolean,
      required: true,
    },
    videoTime: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    hasCompleted(type) {
      switch (type) {
        case 'video':
          return this.hasWatched ? '#00DEA0' : '#808080'
        case 'quiz':
          return this.hasPassedQuiz ? '#00DEA0' : '#808080'
        default:
          return '#808080'
      }
    },
    isContentSelected(type) {
      switch (type) {
        case 'video':
          if (this.isLoading) {
            return 'actions__trigger actions__trigger--disabled'
          }
          if (this.isWatching) {
            return 'actions__trigger actions__trigger--selected'
          }
          return 'actions__trigger'
        case 'quiz':
          if (this.isLoading) {
            return 'actions__trigger actions__trigger--disabled'
          }
          if (this.isTakingQuiz) {
            return 'actions__trigger actions__trigger--selected'
          }
          return 'actions__trigger'
        default:
          return 'actions__trigger'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  align-items: center;
  width: 100%;
  &__video-duration {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .data {
    margin: -3px 0 0 0;
  }
  &__trigger {
    border: none;
    background: var(--dark-gray);
    height: 52px;
    width: 52px;
    position: relative;
    margin: 0 4px 0 0;
    cursor: pointer;
    &:hover {
      background: var(--white);
    }
    &--selected {
      border-bottom: 4px solid var(--green);
    }
    &--disabled {
      pointer-events: none;
    }
  }
  &__icon {
    vertical-align: middle;
    height: 25px;
    width: 30px;
  }
  &__loader {
    position: absolute;
    right: 6px;
    top: 6px;
  }
}
</style>
